// Module: customers — «المراجعون / الزبائن» (HANDOFF §3, §5.2). Rail label
// and title come from the term profile (t('customers')).
//
// Menu (HANDOFF §3 order): «السجل» (`/customers`) · «الملف الطبي» (`./medical`,
// erp.medical, clinic/dental sectors only) · «الاستيراد» (`./import`, owner).
//
// Profile panel: `/customers?customer=<id>` from any screen (customerHref).

import { Users } from 'lucide-react';
import { defineModule } from '@/app/module-types';
import { importMenu, importRoutes } from './import';
import { medicalMenu, medicalRoutes } from './medical';

export default defineModule({
  key: 'customers',
  label: 'المراجعون',
  termLabel: 'customers',
  icon: Users,
  flag: 'erp.core',
  minRole: 'staff',
  rail: 'customers',
  routes: [
    { path: '/customers', lazy: () => import('./screens/CustomersRoute').then((m) => ({ Component: m.CustomersRoute })) },
    ...medicalRoutes,
    ...importRoutes,
  ],
  menu: [{ key: 'records', label: 'السجل', to: '/customers' }, ...medicalMenu, ...importMenu],
});
